import React, { useEffect, useState } from 'react'
import { ArrowLeft, ChevronLeft, ChevronRight, Trash2 } from 'react-feather'
import { useTranslation } from 'react-i18next'
import RestaurantService from '../../../core/services/RestaurantService'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import StageBar from '../stage-bar/stageBar'
import ImageWithBasePath from '../../../components/general/ImageCustom'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
const KitchenDisplay = ({ stages, orders, kitchenId, setKitchenDisplay, setStages, setOrders }) => {
  const MySwal = withReactContent(Swal)
  const { t } = useTranslation()

  const preparationStage = stages.reduce((acc, stage) => {
    acc[stage.display_name] = stage.id
    return acc
  }, {})

  const [activeStage, setActiveStage] = useState()

  useEffect(() => {
    if (!activeStage) {
      setActiveStage(preparationStage['To prepare'])
    }
  }, [preparationStage])
  const showConfirmationTakeNoteAlert = (lineId) => {
    MySwal.fire({
      title: t('check_note_confirm'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: 'Đồng ý',
      cancelButtonColor: '#ff0000',
      cancelButtonText: 'Không',
    }).then((result) => {
      if (result.isConfirmed) {
        // MySwal.fire({
        //   title: 'Done !',
        //   className: 'btn btn-success',
        //   confirmButtonText: 'OK',
        //   customClass: {
        //     confirmButton: 'btn btn-success',
        //   },
        // })
        toggleLineThrough(lineId)
      } else {
        MySwal.close()
      }
    })
  }

  const showConfirmationRemoveTakeNoteAlert = (lineId) => {
    MySwal.fire({
      title: t('remove_check_note_confirm'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: 'Đồng ý',
      cancelButtonColor: '#ff0000',
      cancelButtonText: 'Không',
    }).then((result) => {
      if (result.isConfirmed) {
        // MySwal.fire({
        //   title: 'Done !',
        //   className: 'btn btn-success',
        //   confirmButtonText: 'OK',
        //   customClass: {
        //     confirmButton: 'btn btn-success',
        //   },
        // })
        toggleLineThrough(lineId)
      } else {
        MySwal.close()
      }
    })
  }

  const showConfirmationChangeStageAlert = (orderId, orderStage) => {
    MySwal.fire({
      title: t('change_stage_confirm'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: 'Đồng ý',
      cancelButtonColor: '#ff0000',
      cancelButtonText: 'Không',
    }).then((result) => {
      if (result.isConfirmed) {
        // MySwal.fire({
        //   title: 'Done !',
        //   className: 'btn btn-success',
        //   confirmButtonText: 'OK',
        //   customClass: {
        //     confirmButton: 'btn btn-success',
        //   },
        // })
        changeOrderStage(orderId, kitchenId, orderStage + 1)
      } else {
        MySwal.close()
      }
    })
  }

  const showConfirmationDeleteAlert = (orderId) => {
    MySwal.fire({
      title: t('delete_state_confirm'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: 'Đồng ý',
      cancelButtonColor: '#ff0000',
      cancelButtonText: 'Không',
    }).then((result) => {
      if (result.isConfirmed) {
        // MySwal.fire({
        //   title: 'Done !',
        //   className: 'btn btn-success',
        //   confirmButtonText: 'OK',
        //   customClass: {
        //     confirmButton: 'btn btn-success',
        //   },
        // })
        doneOrderStage(orderId, kitchenId)
      } else {
        MySwal.close()
      }
    })
  }

  const showConfirmationDeleteAllAlert = () => {
    MySwal.fire({
      title: t('delete_all_state_confirm'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: 'Đồng ý',
      cancelButtonColor: '#ff0000',
      cancelButtonText: 'Không',
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: t('notify_done'),
          className: 'btn btn-success',
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
        doneAllOrderStage()
      } else {
        MySwal.close()
      }
    })
  }

  const getOrdersByStage = (stageId) => {
    return orders.filter((order) => order.stage_id === stageId)
  }

  const getStageById = (stageId) => {
    stages.forEach((stage) => {
      return (preparationStage[stage.display_name] = stage.id)
    })
    return Object.keys(preparationStage).find((key) => preparationStage[key] === stageId)
  }

  const getStageIdByName = (stageName) => {
    return stages?.find((stage) => stage.display_name === stageName)?.id
  }

  const stageOrderCount = stages.map((stage) => {
    const orderCount = orders.filter((order) => order.stage_id === stage.id).length
    return { ...stage, total_orders: orderCount }
  })

  const [lineThroughItems, setLineThroughItems] = useState([])
  const [isLineOpen, setIsLineOpen] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 8
  const currentOrders = getOrdersByStage(activeStage)
  const totalPages = Math.ceil(currentOrders.length / itemsPerPage)
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = currentOrders.slice(indexOfFirstItem, indexOfLastItem)

  // Filter orders by stage

  const toggleLineThrough = (itemId) => {
    setLineThroughItems(
      (prev) =>
        prev.includes(itemId)
          ? prev.filter((id) => id !== itemId) // Remove item if it exists
          : [...prev, itemId] // Add item if it doesn't exist
    )
  }

  const toggleLineOpen = (lineId) => {
    setIsLineOpen(
      (prev) =>
        prev.includes(lineId)
          ? prev.filter((id) => id !== lineId) // Remove item if it exists
          : [...prev, lineId] // Add item if it doesn't exist
    )
  }
  const getPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 5
    const halfVisible = Math.floor(maxVisiblePages / 2)

    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }
    return pageNumbers
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const changeOrderStage = async (orderId, kitchenId, stageId) => {
    await RestaurantService.changePreparationStage(orderId, kitchenId, stageId).then(async () => {
      const [kitchenDisplayData] = await Promise.all([RestaurantService.getPreparationDisplayData(kitchenId)])
      if (kitchenDisplayData) {
        setKitchenDisplay(kitchenDisplayData)
        setStages(kitchenDisplayData.stages)
        setOrders(kitchenDisplayData.orders)
      }
    })
  }

  const doneOrderStage = async (orderId, kitchenId) => {
    await RestaurantService.donePreparationStage(orderId, kitchenId).then(async () => {
      const [kitchenDisplayData] = await Promise.all([RestaurantService.getPreparationDisplayData(kitchenId)])
      if (kitchenDisplayData) {
        setKitchenDisplay(kitchenDisplayData)
        setStages(kitchenDisplayData.stages)
        setOrders(kitchenDisplayData.orders)
      }
    })
  }

  const doneAllOrderStage = async () => {
    let orderCompleteIds = orders
      .filter((order) => order.stage_id === preparationStage['Completed'])
      .map((order) => order.id)
    await RestaurantService.donePreparationStage(orderCompleteIds, kitchenId).then(async () => {
      const [kitchenDisplayData] = await Promise.all([RestaurantService.getPreparationDisplayData(kitchenId)])
      if (kitchenDisplayData) {
        setKitchenDisplay(kitchenDisplayData)
        setStages(kitchenDisplayData.stages)
        setOrders(kitchenDisplayData.orders)
      }
    })
  }

  const checkCompletedStage = (stageId) => {
    return stageId === preparationStage['Completed']
  }

  console.log(lineThroughItems, 'lineThroughItems')

  return (
    <div>
      <div className='page-wrapper-pos fade-in p-2'>
        <div className='content'>
          <div className='inline-flex h-16 w-full items-center justify-start gap-6 border-b border-[#e8e8e8] bg-white px-8 py-3'>
            <div className='flex h-10 shrink grow basis-0 items-center justify-between'>
              <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                <Link
                  to='/pos-session'
                  className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'
                >
                  <ImageWithBasePath src='assets/img/POS/arrow-left.svg' alt='' />
                </Link>
              </div>
              <div className="font-['Inter'] text-xl font-medium text-[#0e121b] opacity-0">Bàn 8 - ATOM</div>
              <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                <div className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'>
                  <div
                    className='dropdown pos-menu-action'
                    onClick={(e) => {
                      e.preventDefault()
                    }}
                  >
                    <Link
                      className='dropdown-toggle'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                      onClick={(e) => {
                        e.preventDefault()
                      }}
                    >
                      <ImageWithBasePath src='assets/img/POS/setting-2.svg' alt='' />
                    </Link>
                    <ul className='dropdown-menu'>
                      <li>
                        <Link
                          to='#'
                          className='dropdown-item confirm-text mb-0'
                          onClick={(e) => {
                            e.preventDefault()
                            showConfirmationDeleteAllAlert()
                          }}
                        >
                          <span className='d-flex align-items-center me-1'>
                            <Trash2 className='feather-16 mr-2' />
                            {t('delete_all_complete_order')}
                          </span>
                        </Link>
                      </li>

                      <li>
                        <Link to='/pos-session' className='dropdown-item'>
                          <span className='d-flex align-items-center me-1'>
                            <ArrowLeft className='feather-16 mr-2' />
                            {t('back')}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex align-items-center justify-content-center mt-4'>
            <div className='inline-flex w-full flex-col items-center justify-center gap-2.5 rounded-lg bg-white p-3'>
              <StageBar statusOptions={stageOrderCount} defaultValue={activeStage} setActiveStage={setActiveStage} />
            </div>
          </div>

          {currentItems.length > 0 ? (
            <div
              style={{ minHeight: '70vh' }}
              className='employee-grid-widget mt-4 flex w-full justify-between rounded-[10px] border border-[#F2F2F2] bg-white p-3 p-6 md:p-6'
            >
              <div className='grid grid-cols-1 gap-4 p-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
                {preparationStage != null ? (
                  currentItems.map((order) => (
                    <div
                      key={order.id}
                      className='inline-flex h-fit flex-col items-start justify-center gap-3 rounded-lg border border-[#eff1f4] bg-white p-4 shadow'
                    >
                      <div className='flex h-fit flex-col items-start justify-center gap-2 self-stretch'>
                        <div className='inline-flex items-center justify-between self-stretch'>
                          <div className='flex items-center justify-center gap-1 rounded border border-[#fd525b] px-2 py-1'>
                            <div className="font-['Inter Display'] text-sm font-medium leading-tight text-[#ff505a]">
                              {order.table.name ? `${t('table')} ${order.table.name}` : 'Take Away'}
                            </div>
                          </div>
                          <div className="font-['Inter Display'] text-base font-semibold leading-normal text-[#0e121b]">
                            Order #{order.id}
                          </div>
                          <div className='flex h-8 w-8 items-center justify-center rounded-[999px] bg-[#f8f8f8] p-1.5'>
                            <div className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'>
                              <div className='relative h-5 w-5'>
                                <ChevronDownIcon
                                  className={`h-5 w-5 transition-transform duration-200 ${isLineOpen.includes(order.id) ? 'rotate-180 transform' : ''}`}
                                  onClick={() => toggleLineOpen(order.id)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {!isLineOpen.includes(order.id) ? (
                          <div className='flex h-full w-full flex-col items-start justify-start border-t border-[#f0f2f5] py-2'>
                            {order.orderlines.map((line) => (
                              <div
                                key={line.id}
                                onClick={() =>
                                  lineThroughItems.includes(line.id)
                                    ? showConfirmationRemoveTakeNoteAlert(line.id)
                                    : showConfirmationTakeNoteAlert(line.id)
                                }
                                className='d-flex w-full items-center justify-between gap-2 self-stretch px-2'
                              >
                                {line.product_cancelled > 0 ? (
                                  <div className='flex w-full items-center justify-between'>
                                    <div className='flex items-center gap-1'>
                                      <div className="font-['Inter Display'] text-sm font-medium text-neutral-400 line-through">
                                        {line.product_name}
                                      </div>
                                      <div
                                        className='rounded px-2 py-1 text-xs font-bold text-white'
                                        style={{
                                          backgroundColor: '#FF505B',
                                        }}
                                      >
                                        {line.product_cancelled} {t('order_cancelled')}
                                      </div>
                                    </div>
                                    <div className='flex h-9 items-center justify-center gap-1.5 rounded-lg border border-[#f0f2f5] p-1'>
                                      <div className="font-['Inter Display'] p-2 text-sm font-semibold text-neutral-400 line-through">
                                        {line.product_quantity}x
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className='flex w-full items-center justify-between gap-2 rounded-lg p-1'
                                    style={{
                                      backgroundColor: lineThroughItems.includes(line.id) ? '#f3f4f7' : 'none',
                                    }}
                                  >
                                    <div
                                      className="font-['Inter Display'] text-sm font-medium leading-tight text-[#0e121b]"
                                      style={{
                                        color: lineThroughItems.includes(line.id) ? '#9DABB7' : '#092C4C',
                                        textDecoration: lineThroughItems.includes(line.id) ? 'line-through' : 'none',
                                      }}
                                    >
                                      {line.product_name}
                                    </div>
                                    <div
                                      className='flex h-9 items-center justify-center gap-1.5 rounded-lg border border-[#f0f2f5] p-1'
                                      style={{
                                        border: lineThroughItems.includes(line.id) ? 'none' : 'solid 1px #f0f2f5',
                                      }}
                                    >
                                      <div
                                        className="font-['Inter Display'] p-2 text-sm font-semibold leading-tight text-[#0e121b]"
                                        style={{
                                          color: lineThroughItems.includes(line.id) ? '#9DABB7' : '#092C4C',
                                          textDecoration: lineThroughItems.includes(line.id) ? 'line-through' : 'none',
                                          border: 'none',
                                        }}
                                      >
                                        {line.product_quantity - line.product_cancelled}x
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>

                      {order.stage_id != getStageIdByName('Completed') ? (
                        <button
                          onClick={() => showConfirmationChangeStageAlert(order.id, order.stage_id)}
                          className={`inline-flex h-10 items-center justify-center gap-2.5 self-stretch rounded-lg border ${order.stage_id != getStageIdByName('Ready') ? 'bg-[#FD525B]' : 'bg-[#28C76F]'} px-4 py-2.5`}
                        >
                          <span className="font-['Inter'] text-sm font-medium leading-tight text-white">
                            {t(`${getStageById(order.stage_id + 1)}`)}
                          </span>
                        </button>
                      ) : (
                        <button
                          onClick={() => showConfirmationDeleteAlert(order.id)}
                          className='inline-flex h-10 items-center justify-center gap-2.5 self-stretch rounded-lg border bg-[#525866] px-4 py-2.5'
                        >
                          <span className="font-['Inter'] text-sm font-medium leading-tight text-white">
                            {t('delete_kitchen_order')}
                          </span>
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>{' '}
            </div>
          ) : (
            <div
              style={{ minHeight: '70vh' }}
              className='d-flex align-items-center flex-column justify-center rounded-[10px] border border-[#F2F2F2] bg-white p-6'
            >
              <ImageWithBasePath src='assets/img/empty-content.svg' alt='empty-doc' />
              <span style={{ fontSize: '24px', fontWeight: '600' }} className='text-center'>
                {t('no_data_found')}
              </span>
            </div>
          )}

          {totalPages > 0 && (
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='mb-3 mt-4 flex items-center justify-center gap-2'>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className='rounded p-2 hover:bg-gray-100 disabled:opacity-50'
                    >
                      <ChevronLeft className='h-5 w-5' />
                    </button>

                    {getPageNumbers().map((number) => (
                      <button
                        key={number}
                        onClick={() => handlePageChange(number)}
                        className={`rounded px-3 py-1 ${
                          currentPage === number ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                        }`}
                      >
                        {number}
                      </button>
                    ))}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className='rounded p-2 hover:bg-gray-100 disabled:opacity-50'
                    >
                      <ChevronRight className='h-5 w-5' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default KitchenDisplay
